// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-expansion-panel{border-top:1px solid var(--color-neutral-500);border-radius:0!important}.v-expansion-panel:last-child{border-bottom:1px solid var(--color-neutral-500)}.v-expansion-panel:before{box-shadow:none}.v-expansion-panel-header{padding:25px 0;color:#36134a;font-weight:700}.v-expansion-panel-content__wrap{padding-right:0;padding-left:0;font-size:14px}", ""]);
// Exports
module.exports = exports;
